const initState = {
  subscriptionData: [],
};
const subscriptionReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SUBSCRIPTION_BY_ID":
      return {
        ...state,
        subscriptionData: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default subscriptionReducer;
